import script from "./VerizonAccountName.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerizonAccountName.vue?vue&type=script&setup=true&lang=ts"

import "./VerizonAccountName.vue?vue&type=style&index=0&id=0d3dbf9e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3dbf9e"]])

export default __exports__